<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { format_daymonth, format_time_of_day} from './time';
  import ParticipantList from './ParticipantList.svelte';
  import WorkoutChart from './workouts/WorkoutChart.svelte';
  import TrainingCardLong from '@/MyFitness/Today/TrainingCardLong.svelte';
  import ExerciseCardButtons from './ExerciseCard/ExerciseCardButtons.svelte';
  import ExerciseImageCarousel from './ExerciseCard/ExerciseImageCarousel.svelte';
  import Avatar from './Avatar.svelte';
  import YouTube from './YouTube.svelte';
  import { getContext } from 'svelte';
  import { TagWrapper } from './Common';
  import { ActivityTag } from './Common/ActivityTag';

  export let joined: boolean = false;
  export let name: string;
  export let session_id: string = null;
  export let template_id: string = null;
  export let community: string = null;
  export let club: any = null;
  export let chart_url: string = null;
  export let images: string[] = null;
  export let description: string = null;
  export let workout_id: string = null;
  export let workout_name: any;
  export let invited_users: any[] = null;
  export let members: any[];
  export let allowed_users: any[] = null;
  export let is_group_session: boolean = false;
  export let start_date: string = null;
  export let owner: any;
  export let sharing_type: string = null;
  export let repeat_type: string = null;

  export let video_id: any = null;
  export let video_offset: any = null;
  export let zoom_url: string = null;
  export let spotify_url: string = null;

  export let tags: any[] = [];
  export let venue: any = null;
  export let route_url: string = null;

  export let xss: number = null;
  export let xlss: number = null;
  export let xhss: number = null;
  export let xpss: number = null;
  export let xep: number = null;
  export let tgf: number = null;
  export let tgc: number = null;
  export let duration: number = null;
  export let difficulty: number = null;
  export let distance: number = null;
  export let elevation: number = null;
  export let rating: any = null;

  export let focus: any = null;
  export let sfd: number = null;

  export let specificity: any = null;
  export let specRating: any = null;
  export let spr: any = null;
  export let suitability: any = null;
  
  export let current_time;

  export let is_owner: boolean;
  export let logged_in;

  let is_template = template_id && !session_id;

  let start_date_obj = null;
  let starting_at_date = null;
  let starting_at_time = null;

  $: if (!is_template) {

    console.log(start_date);
    start_date_obj = new Date(start_date);
    starting_at_date = format_daymonth(start_date_obj, $current_time);
    starting_at_time = format_time_of_day(start_date_obj, $current_time);

    //let xert = getContext('xert');
    //$: is_public = sharing_type == "public";
  }

  let video_url = video_id == null ? null : `https://www.youtube.com/watch?v=${video_id}`;

  function updateTags(repeat_type: string, sharing_type: string, tags: string[]) {
    const activityTag = ActivityTag("default")
    return [
      activityTag.exerciseType({exerciseType: "Session"}),
      activityTag.repeat({repeat_type}),
      activityTag.sharing({sharing_type}),
      ...activityTag.list(tags)
    ].filter(tag => tag)
  }

</script>


<coarse-grid>
<div class="col">
  <flex-container class="grid-outline">

  {#if workout_id}
    {#if logged_in}
    <WorkoutChart {workout_id}/>
    {:else}
    <img class="workout-thumb" src="{chart_url}" on:error={e=>e.target.style.visibility='hidden'} alt={$_("workouts.alt.workout_thumb", {values: {name: name}})}/>
    {/if}
  {/if}

  <h2 class="w500">
    {name}
  </h2>

  <flex-container class="flex-row" style="margin-bottom: 10px;">
    {#if !is_template && club?.logo}
      <img class="club-logo" src={club.logo}/>
    {/if}

    {#if !is_template}
      <span class="medium w500 margin-vcentre" style="flex-grow: 1; margin-right: 16px">
        {starting_at_date} - {starting_at_time}
        <br style="margin-bottom:18px;"/>
        {#if club != null}
          <!-- {$_("clubs."+club.type)}: {club.name}<br/> -->
          {club.display_name} - 
        {/if}
        {owner.first_name} {owner.last_name} <Avatar {...owner}/>
      </span>
    {/if}

    <div style="display: flex; flex-direction: column; gap: 10px; margin: 10px 0;">
      <flex-container class="flex-row">
        <ExerciseCardButtons path={is_template ? template_id : session_id} isTemplate={is_template} isSession={true} {video_id} {zoom_url} {spotify_url}/>
      </flex-container>
      <TagWrapper tags={updateTags(repeat_type, sharing_type, tags)} />
    </div>
  </flex-container>
  <TrainingCardLong exercise={{duration, xss, xlss, xhss, xpss, xep, tgf, tgc, focus, sfd, specRating, rating, name: workout_name, description, difficulty, suitability}} showChartImage={false} forceShowDescription={true} showButtons={false}/>
  </flex-container>

  <!--Show media/video in left side panel if it is a scheduled session.-->
  {#if !is_template && (video_url != null || images != null)}
  <flex-container class="grid-outline">
  {#if video_url != null && video_url.length > 0}
  <div class="desc-item">
    <YouTube video_url={video_url} video_id={video_id} start_seconds={video_offset}/>
  </div>
  {/if}
  {#if images != null && images.length > 0}
  <div class="desc-item" style="margin: auto;">
    <ExerciseImageCarousel {images} height={300}/>
  </div>
  {/if}
  </flex-container>
  {/if}

</div>

{#if !is_template}
<flex-container class="col" >

  <div class="grid-outline">
  <h4 class="w500">
    {$_('sessions.details.participants')} ({members?.length ?? 0})

  </h4>
  <ParticipantList {owner} {sharing_type} {invited_users} {members} hilight_invited={false} users_to_schedule={members.map(u=>u.id)} users_to_invite={invited_users} club_users={[]} />
  </div>
</flex-container>
<!--Show media/video in right side panel if it is a template.-->
{:else if (video_url != null || images != null)}
  <flex-container class="grid-outline">
  {#if video_url != null && video_url.length > 0}
  <div class="desc-item">
    <YouTube video_url={video_url} video_id={video_id} start_seconds={video_offset}/>
  </div>
  {/if}
  {#if images != null && images.length > 0}
  <div class="desc-item" style="margin: auto;">
    <ExerciseImageCarousel {images} height={300}/>
  </div>
  {/if}
  </flex-container>
{/if}

</coarse-grid>

<style lang="scss">
  // TODO: Figure out how to appy theme globally?
  @import './style/xert.scss';

  flex-container {
    display: flex;
    flex-direction: column;
    align-content: stretch;

    > div.desc-item {
      flex: 1 0 200px;
    }

    > img.workout-thumb {
      display: inline-block;
      object-fit: contain;
      margin: 0 24px 0 0;
      border: 1px solid #ECECEC;
      border-radius: 4px;
    }
    > img.club-logo {
      display: inline-block;
      object-fit: contain;
      height: 80px;
      width: 80px;
      margin: 0 24px 0 0;
      /* filter: drop-shadow(0.25rem 0.25rem 0.5rem black); */
      //box-shadow: 2px 2px 10px -2px gray;
      border: 1px solid #ECECEC;
      border-radius: 4px;
    }
  }
</style>
